export const ADMIN_ROLE = "Direttore";
export const TOWER_ROLE = "Addetto torre di controllo";
export const NOSTROMO_ROLE = "Nostromo";
export const MANUTENTORE_ROLE = "Manutentore";
export const BANCHINA_ROLE = "Addetto di banchina";
export const MANSIONI = ["Manutentore", "Addetto di banchina", "Addetto torre di controllo", "Nostromo", "Operatore subacqueo", "Vigilanza Fiduciario", "Vigilanza GPG", "Responsabile vigilanza", "Uffici Direzione", "Uffici Utenza", "Responsabile amministrativo", "Servizi", "Addetto pulizie", "Direttore"];
export const SHIFT_REPORT_ROLES = [BANCHINA_ROLE, NOSTROMO_ROLE, MANUTENTORE_ROLE, TOWER_ROLE];
export const MARE_ROLES = [...SHIFT_REPORT_ROLES, "Operatore subacqueo"];

export const rolesOf = (u) => (u?.mansioni?.length ? u.mansioni : u?.mansione ? [u.mansione] : []);
export const isAdmin = (u) => rolesOf(u).includes(ADMIN_ROLE) || !!u?.is_admin;
export const hasRole = (u, list) => rolesOf(u).some((r) => list.includes(r));
export const SCAD_ROLES = ["Direttore", "Uffici Utenza", "Responsabile amministrativo", "Uffici Direzione"];
export const VIGILANZA_ROLES = ["Vigilanza Fiduciario", "Vigilanza GPG"];
export const VIG_SUPERVISOR_ROLE = "Responsabile vigilanza";
export const VIG_REPORT_ROLES = [...VIGILANZA_ROLES, VIG_SUPERVISOR_ROLE];
export const canMaint = (u) => isAdmin(u) || hasRole(u, [MANUTENTORE_ROLE, NOSTROMO_ROLE, "Uffici Utenza"]);

const MESI = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
export const toDisplay = (iso) => { if (!iso) return ""; const [y, m, d] = iso.split("-"); return y && m && d ? `${d}/${m}/${y}` : iso; };
export const toIso = (v) => { if (!v || !v.includes("/")) return v || ""; const [d, m, y] = v.split("/"); return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`; };

export function fmtDate(v, withTime = false) {
  if (!v) return "";
  v = /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(v) ? toIso(v) : v;
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  if (isNaN(d)) return v;
  const s = `${d.getDate()} ${MESI[d.getMonth()]} ${d.getFullYear()}`;
  return withTime ? `${s}, ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}` : s;
}
export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
